/* eslint-disable sonarjs/no-hardcoded-passwords */
import { BASE_URL } from './env'

export const ACCOUNT_SUBDOMAIN = 'account'

export const routes = {
  alerts: '/alerts',
  account: '/select-account',
  healthCheck: '/health-check',
  generatedChromium: '/chromium-pack.tar',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  updatePassword: '/update-password',
  index: '/',
  templates: '/slides/templates',
}

export const urls = {
  account: `https://${ACCOUNT_SUBDOMAIN}.${BASE_URL}${routes.account}`,
}
